export default __webpack_public_path__ + "static/media/fi-payment-security-48.bc561470.svg";